/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo de elementos para favoritos:   * actividades   * eventos   * empresas 
 */
export type FavoriteType = 'actividades' | 'eventos' | 'empresas';

export const FavoriteType = {
    Actividades: 'actividades' as FavoriteType,
    Eventos: 'eventos' as FavoriteType,
    Empresas: 'empresas' as FavoriteType
};

